import { Variable } from '../../../services/api/departmentVariablesService';
import { VariableDefault } from '../utils/variableTypes';
import { DepartmentUser } from '../setup-wizard/WizardVariableForm';

interface SaveValidationArgs {
    def: VariableDefault;
    editValue: string;
    editRefId?: string;
    isCustom?: boolean;
}

export function resolveDisplayValue(
    def: VariableDefault,
    saved: Variable | undefined,
    users: DepartmentUser[]
): string {
    if (!saved) return '';

    if (def.field === 'ref') {
        if (saved.refId) {
            return users.find((user) => user.id === saved.refId)?.name ?? '';
        }
        return saved.fixedValue || '';
    }

    return saved.fixedValue || '';
}

export function hasRequiredValue(
    def: VariableDefault,
    editValue: string,
    editRefId?: string
): boolean {
    if (def.field === 'ref') {
        return !!editRefId || editValue.trim().length > 0;
    }

    return editValue.trim().length > 0;
}

export function canSaveVariableRow({
    def,
    editValue,
    editRefId,
    isCustom,
}: SaveValidationArgs): boolean {
    if (def.required && !hasRequiredValue(def, editValue, editRefId)) {
        return false;
    }

    if (isCustom && !editRefId && editValue.trim().length === 0) {
        return false;
    }

    return true;
}
